import { render, staticRenderFns } from "./ServiceFormView.vue?vue&type=template&id=746a2641&scoped=true&"
import script from "./ServiceFormView.vue?vue&type=script&lang=js&"
export * from "./ServiceFormView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormView.vue?vue&type=style&index=0&id=746a2641&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746a2641",
  null
  
)

export default component.exports